/** Roles that make an element a control in its own right. */
const CONTROL_ROLES = new Set([
  "button",
  "link",
  "checkbox",
  "radio",
  "switch",
  "tab",
  "menuitem",
  "menuitemcheckbox",
  "menuitemradio",
  "option",
  "combobox",
  "slider",
  "spinbutton",
  "textbox",
  "searchbox",
]);

/** Whether an element is a control that should own its own clicks. */
function isControl(el: Element): boolean {
  if (el.hasAttribute("data-pressable-control")) return true;
  switch (el.tagName) {
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
    case "SUMMARY":
      return true;
    case "A":
      return el.hasAttribute("href");
    case "INPUT":
      return (el as HTMLInputElement).type !== "hidden";
    case "LABEL":
      return (el as HTMLLabelElement).control != null;
  }
  if (el instanceof HTMLElement && el.isContentEditable) return true;
  const role = el.getAttribute("role");
  return role != null && role.split(/\s+/).some((r) => CONTROL_ROLES.has(r));
}

/**
 * Whether an event started on a control nested inside the Pressable: the
 * target itself or any ancestor up to, but not including, the Pressable's own
 * element. Such a press belongs to the inner control, so the Pressable leaves
 * it alone. Mark a custom control with `data-pressable-control` if it has no
 * role or native element that says so.
 */
export function startedOnInnerControl(target: EventTarget | null, pressable: Element): boolean {
  for (let el = target instanceof Element ? target : null; el && el !== pressable; ) {
    if (isControl(el)) return true;
    el = el.parentElement;
  }
  return false;
}
